import {LienItemModel} from './lien-item.model';

export class MenuItemModel {
  iconClass: string;
  libelle: string;
  routerLink: string;
  sousMenu: Array<LienItemModel>;
}
